import { useState, useContext, useEffect }  from 'react';
import { useNavigate, useLocation } from "react-router";
import useAuth from "../../hooks/useAuth";
import axios from "axios";


const Logout = () => {
    
    const navigate = useNavigate();
    const { auth, setAuth } = useAuth();
    const [error, setError] = useState("");
    localStorage.removeItem("some-key")

    useEffect(() => {
        const API = axios.create({
            baseURL: process.env.REACT_APP_BASE_URL,
            withCredentials: true,
        });
        const userLogout = async () => {
            try {
                const res = await API.post("/auth/logout", {}).then((res) => {
                    console.log(res.message)
                    console.log("auth before logout:",auth)
                    setAuth({ role: "", name: "" });
                    console.log("auth after logout:",auth)
                    navigate("/", { replace: true });
                })
                console.log('working');
            } catch (err) {
                if (!err?.response) {
                    setError("no server response");
                } else {
                console.log(err)
                    setError("logout failed");
                }
            }
        };
        userLogout();
    }, []);

    return (
        <div>
            Logging out...
            <p>{error}</p>
        </div>
    );
}

export default Logout;